import { Button, darken, styled, Theme, Typography } from "@material-ui/core";
import Imgix from "react-imgix";

export const Wrapper = styled("div")(
  ({ theme, color }: { theme: Theme; color: "gray" | "yellow" }) => ({
    position: "relative",
    backgroundColor:
      color === "yellow" ? theme.palette.primary.main : theme.palette.grey[300],
    transition: "background 500ms",
    borderRadius: "8px",
    height: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2, 4, 2, 14),
    overflow: "hidden",
    [theme.breakpoints.only("md")]: {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(12)
    },
    [theme.breakpoints.only("sm")]: {
      height: "auto",
      alignItems: "flex-start",
      justifyContent: "space-between",
      flexDirection: "column",
      paddingLeft: theme.spacing(13)
    },
    [theme.breakpoints.only("xs")]: {
      height: "auto",
      minHeight: "150px",
      alignItems: "flex-start",
      flexDirection: "column",
      padding: theme.spacing(2, 2, 2, 2),
      borderRadius: "3px"
    }
  })
);

export const PodImage = styled(Imgix)(({ theme }) => ({
  position: "absolute",
  top: "9px",
  left: "12px",
  userSelect: "none",
  [theme.breakpoints.only("md")]: {
    top: "4px"
  },
  [theme.breakpoints.only("sm")]: {
    top: "8px",
    left: "16px"
  },
  [theme.breakpoints.only("xs")]: {
    top: "13px",
    left: "16px"
  },
  [theme.breakpoints.up("md")]: {
    top: "9px",
    left: "12px",
    width: 147 / 2,
    height: 211 / 2
  }
}));

export const PodCounter = styled("div")(({ theme }) => ({
  fontFamily: "Roobert",
  fontWeight: 600,
  position: "absolute",
  top: "11px",
  left: "52px",
  width: "25px",
  height: "25px",
  background: "rgb(252, 78, 18)",
  color: "#FFFFFF",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  [theme.breakpoints.down("sm")]: {
    top: "9px",
    left: "53px"
  },
  [theme.breakpoints.up("sm")]: {
    top: "6px",
    left: "56px"
  },
  [theme.breakpoints.up("md")]: {
    left: "62px"
  }
}));

export const Actions = styled("div")(({ theme }) => ({
  display: "flex",
  [theme.breakpoints.up("md")]: {
    marginLeft: theme.spacing(2)
  },
  [theme.breakpoints.down("xs")]: {
    alignSelf: "stretch",
    "& a, & > div": {
      display: "block",
      flex: 1
    },
    "& button": {
      width: "100%"
    }
  }
}));

export const MainTypography = styled(Typography)(({ theme }) => ({
  fontFamily: "Reckless",
  fontSize: "2.3rem",
  lineHeight: "2.8rem",
  [theme.breakpoints.down("md")]: {
    fontSize: "2rem",
    lineHeight: "2.2rem"
  },
  [theme.breakpoints.only("sm")]: {
    fontSize: "2.2rem",
    lineHeight: "2.4rem",
    marginBottom: theme.spacing(2),
    whiteSpace: "nowrap"
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: "1.9rem",
    lineHeight: "2.4rem",
    marginLeft: theme.spacing(8.5),
    marginTop: theme.spacing(1)
  }
}));

export const CustomButton = styled(Button)(({ theme }) => ({
  minHeight: "0px",
  height: "28px",
  minWidth: "220px",
  fontWeight: 600,
  borderRadius: "32px",
  fontSize: "1.3rem",
  lineHeight: "1.6rem",
  [theme.breakpoints.down("md")]: {
    minWidth: "180px"
  },
  [theme.breakpoints.down("xs")]: {
    minWidth: "0px",
    height: "28px",
    whiteSpace: "nowrap"
  }
}));

export const DefaultButton = styled(CustomButton)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  "&:hover": {
    backgroundColor: theme.palette.grey[200]
  }
}));

export const ReferButton = styled(CustomButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  "&:hover": {
    backgroundColor: theme.palette.primary.dark
  }
}));

export const ExpressDeliveryButton = styled(CustomButton)(({ theme }) => ({
  backgroundColor: theme.palette.expressDelivery,
  color: theme.palette.common.white,
  "&:hover": {
    backgroundColor: darken(theme.palette.expressDelivery, 0.1)
  }
}));
